import styled, { css } from 'styled-components';
import { transparentize } from 'polished';
import { motion } from 'framer-motion';
import { colors } from '@keen.io/colors';
export var Container = styled.li.withConfig({
  displayName: "ListItemstyles__Container",
  componentId: "keen-query-creator__sc-hr4ka6-0"
})(["&&&{padding:8px 14px;display:flex;align-items:center;justify-content:space-between;font-size:14px;font-family:'Lato Regular',sans-serif;color:", ";cursor:pointer;transition:background 0.2s linear;", ";}&&&:hover{background:", ";}"], colors.blue[500], function (props) {
  return props.isActive && css(["background:", ";"], transparentize(0.8, colors.green[100]));
}, transparentize(0.8, colors.green[100]));
export var Hint = styled.div.withConfig({
  displayName: "ListItemstyles__Hint",
  componentId: "keen-query-creator__sc-hr4ka6-1"
})(["&&&{display:flex;align-items:center;}"]);
export var MotionIcon = styled(motion.div).withConfig({
  displayName: "ListItemstyles__MotionIcon",
  componentId: "keen-query-creator__sc-hr4ka6-2"
})(["&&&{display:flex;align-items:center;}"]);